/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import config from "../config/activityLists.config.json";
// import { useOrgId } from "../provider";

// import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
// import { GET_USER_LIST } from "../graphql";
import { VApplication } from "../../../application";
import moment from "moment-timezone";

// const getGraphQLModule = () => {
//   const app = VApplication.getInstance();
//   return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
// };

export interface IActivityListsMethods extends IPluginMethodMap {
  getActivityListsProps(args: any): Promise<any>;
}

export class UserListsService implements IAgentPlugin {
  readonly methods: IActivityListsMethods;

  constructor() {
    this.methods = {
      getActivityListsProps: this.getActivityListsProps.bind(this),
    };
  }

  async getActivityListsProps(args: any) {
    // const graphqlModule = getGraphQLModule();
    // const client = graphqlModule.getClient("graphql-gateway");
    // const { orgId } = useOrgId();
    // try {
    //   if (client) {
    //     const res = await client.query({
    //       query: GET_USER_LIST,
    //       variables: {
    //         input: {
    //           skip: args?.offset ?? 0,
    //           limit: args?.size ?? 10,
    //           where: [
    //             {
    //               column: "org",
    //               value: [orgId],
    //               op: "Equal",
    //             },
    //             ...args?.where,
    //           ],
    //           order: [
    //             {
    //               column: "createdAt",
    //               direction: "DESC",
    //             },
    //           ],
    //         },
    //       },
    //       fetchPolicy: "network-only",
    //     });
    //     if (res?.data) {
    //       console.log(`table data`, res);
    //       let _rowData = this.formatUserTable(res?.data?.getUserList?.data);
    //       console.log(`row data`, _rowData);
    //       return {
    //         ...config,
    //         ultUsers: _rowData,
    //         isEmpty: res?.data?.getUserList?.data?.length <= 0,
    //         // studentGroup: holderGroups,
    //         activePage: res?.data?.getUserList?.currentPage,
    //         pageSize: res?.data?.getUserList?.pageSize,
    //         totalCount: res?.data?.getUserList?.totalCount,
    //         totalPages: res?.data?.getUserList?.totalPages,
    //       };
    //     }
    //   }
    // } catch (err: any) {
    //   console.log(`error in table data`, err);
    //   return {
    //     isEmpty: true,
    //   };
    // }
    return { ...(config || {}) };
  }

  private formatUserTable(data: any) {
    let _rowData: any =
      Array.isArray(data) &&
      data.map((item: any) => {
        return {
          id: item?.vuid,
          // status: item?.status,
          status: this.getFormattedStatus(item?.accountStatus, item?.suspended),
          name: `${item?.firstName ?? ""} ${item?.lastName ?? ""}`,
          email: item?.email,
          dateCreated: this.formatCreatedDate(item?.createdAt),
          role: ["teller"],
          image:
            item?.image ??
            `https://ui-avatars.com/api/?name=${item?.firstName}+${item?.lastName}&background=0D8ABC&color=fff`,
          verified: item?.emailVerified,
        };
      });

    return _rowData;
  }

  private formatCreatedDate(date: Date) {
    if (date) {
      return moment(date).format("LLL");
    }
    return "-";
  }

  private getFormattedStatus(status: string, suspended: boolean) {
    if (suspended) {
      return "suspended";
    } else {
      switch (status) {
        case "USER_ADDED":
          return "created";
        case "USER_INVITED":
          return "invited";
        case "USER_EMAIL_VERIFIED":
          return "verified";
        case "USER_VERIFIED":
          return "verified";
        case "USER_ACC_CREATED":
          return "active";
        case "WALLET_REGISTERED":
          return "active";
        case "SUSPENDED":
          return "suspended";
        default:
          return "-";
      }
    }
  }
}
